import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  ChangeEvent,
  SyntheticEvent,
  useMemo,
} from 'react'
import { styled } from '@mui/material/styles'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { format, subDays } from 'date-fns'
import Carousel from 'react-material-ui-carousel'
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  IconButton,
  Box,
  Avatar,
  Stack,
  Divider,
  Backdrop,
  LinearProgress,
  Container,
  Button,
  Paper,
  Drawer,
  Chip,
  Modal,
  TextField,
  SwipeableDrawer,
  Alert,
  Input,
  buttonClasses,
  ButtonProps,
  Dialog,
  DialogContent,
  DialogProps,
} from '@mui/material'
import {
  Create,
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
  Menu,
  Visibility,
  VisibilityOff,
  AccessTime,
  PlayArrow,
  Pause,
  Timer,
} from '@mui/icons-material'
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from 'recoil'

import AddTaskView from '../PracticeDayView/AddTaskView'
import TaskView from '../TaskView/TaskView'
import * as repoutil from '../util/repoutil'
import * as dateutil from '../util/dateutil'
import * as timeutil from '../util/timeutil'
import * as expressionutil from '../util/expressionutil'
import CongratsLottie1 from '../PracticeDayView/congratsLottie1.json'
import CongratsLottie2 from '../PracticeDayView/congratsLottie2.json'
import { useLottie } from 'lottie-react'
import {
  GRAY_DARK,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  GREEN,
  GREEN_LIGHTEST,
} from '../theme/theme'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { PracticeDayDetailedOutputDto } from '../types/practiceDay'
import { GradientButton } from '../Components/Button'
import { PracticeTaskCategory } from '../PracticeDayView/common'
import NonSongPracticeTaskHeader from './NonSongPracticeTaskHeader'
import { z } from 'zod'
import { PracticeNoteOutputDto } from '../types/practiceNote'
import PracticeTaskGroupListView from './PracticeTaskListView'
import styles from './PracticePage.module.css'
import { getCreatePracticeTaskPageUrl } from '../config/config'
import { YYYYMMDDDateString } from '../types/common'
import { Controller, useForm } from 'react-hook-form'
import PracticeTaskListView from './PracticeTaskListView'
import useCurrentDate from '../hooks/useCurrentDate'
import usePracticeDayMap from '../hooks/usePracticeDayMap'
import { useTranslation } from 'react-i18next'
import { ClickMoveButton } from '../pixel'

const style = {
  position: 'absolute',
  overflowY: 'auto',
  scrollbarWidth: 'none',
  bgcolor: GRAY_LIGHTEST,
  borderRadius: '10px',
  minHeight: '100vh',
  maxHeight: '100vh',
}

interface PracticePageProps {}

const TimeUnit = z.enum(['HOUR', 'MINUTE', 'SECOND'])
type TimeUnit = z.infer<typeof TimeUnit>

interface Timer {
  isRunning: boolean
  startedAt: Date | null
  elapsedDurationMillisecond: number
  deltaDurationMillisecond: number
  [TimeUnit.Enum.HOUR]: number
  [TimeUnit.Enum.MINUTE]: number
  [TimeUnit.Enum.SECOND]: number
}

interface UpdateTimerFormData {
  [TimeUnit.Enum.HOUR]: number
  [TimeUnit.Enum.MINUTE]: number
  [TimeUnit.Enum.SECOND]: number
}

const defaultTimerBuffer = (): UpdateTimerFormData => ({
  [TimeUnit.Enum.HOUR]: 0,
  [TimeUnit.Enum.MINUTE]: 0,
  [TimeUnit.Enum.SECOND]: 0,
})

const buildHourMinuteSecond = (durationMillisecond: number) => {
  const hour = Math.floor(durationMillisecond / 1000 / 60 / 60)
  const minute = Math.floor(
    (durationMillisecond - hour * 60 * 60 * 1000) / 1000 / 60,
  )
  const second = Math.floor(
    (durationMillisecond - hour * 60 * 60 * 1000 - minute * 60 * 1000) / 1000,
  )
  return {
    [TimeUnit.Enum.HOUR]: hour,
    [TimeUnit.Enum.MINUTE]: minute,
    [TimeUnit.Enum.SECOND]: second,
  }
}

// 특정 일자의 연습을 수정하는 모달창
// 오늘의 연습 시작 화면 등도 결국 특정 일자의 연습을 수정하는 것이기에 이 모달창에서 진행될 수 있다.
export default function PracticePage({}: PracticePageProps) {
  const { t } = useTranslation()
  const [currentDate] = useCurrentDate()
  const [practiceDayMap, refreshPracticeDay] = usePracticeDayMap()
  const practiceDay = useMemo(() => {
    return practiceDayMap.get(currentDate)
  }, [practiceDayMap, currentDate])

  const navigate = useNavigate()

  const [pinnedPracticeNotes, setPinnedPracticeNotes] = useState<
    PracticeNoteOutputDto[]
  >([])
  const [timerInputType, setTimerInputType] = useState<'text' | 'number'>(
    'number',
  )
  const [timer, setTimer] = useState<Timer>({
    isRunning: false,
    startedAt: null, // new Date()
    elapsedDurationMillisecond: 0,
    deltaDurationMillisecond: 0,
    [TimeUnit.Enum.HOUR]: 0,
    [TimeUnit.Enum.MINUTE]: 0,
    [TimeUnit.Enum.SECOND]: 0,
  })
  const importPracticeButtonRef = useRef<HTMLInputElement>(null)

  console.log(timer)
  const tickerRef = useRef<NodeJS.Timeout | undefined>()

  const refreshPinnedPracticeNotes = async () => {
    const resp = await repoutil.http(`practiceNotes?isPinned=true`)
    const data = await resp.json()
    setPinnedPracticeNotes(data.data as PracticeNoteOutputDto[])
  }
  const [openUpdateTimerDialog, setOpenUpdateTimerDialog] = useState(false)
  const hourRef = useRef<HTMLInputElement>(null)
  const minuteRef = useRef<HTMLInputElement>(null)
  const secondRef = useRef<HTMLInputElement>(null)
  const {
    handleSubmit: handleSubmitUpdateTimer,
    getValues: getValuesUpdateTimer,
    setValue: setValueUpdateTimer,
    reset: resetUpdateTimer,
    control: controlUpdateTimer,
  } = useForm<UpdateTimerFormData>({ defaultValues: defaultTimerBuffer() })

  useEffect(() => {
    refreshPinnedPracticeNotes()
    if (!practiceDay) {
      return
    }
    setTimer({
      ...timer,
      elapsedDurationMillisecond: practiceDay.practiceDuration * 1000,
      ...buildHourMinuteSecond(practiceDay.practiceDuration * 1000),
    })
  }, [practiceDay])

  const { View, play, stop, setSpeed } = useLottie({
    loop: false,
    autoplay: false,
    animationData: CongratsLottie1,
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      width: '100%',
      zIndex: 1000,
    },
  })

  if (!practiceDay) {
    return <div>Loading...</div>
  }

  const onClickAddTask = () => {
    ClickMoveButton('PracticePage', 'AddTaskPage')
    navigate(getCreatePracticeTaskPageUrl())
  }

  const onClickImportPractice = async (e: SyntheticEvent) => {
    ClickMoveButton('PracticePage', 'ImportPracticePage')
    if (importPracticeButtonRef.current) {
      importPracticeButtonRef.current.disabled = true
    }

    navigate(`/practice/import?date=${currentDate}`)

    if (importPracticeButtonRef.current) {
      importPracticeButtonRef.current.disabled = false
    }
  }

  const onClickTimerPlay = () => {
    if (timer.isRunning) return

    setTimer((prev) => {
      return {
        isRunning: true,
        startedAt: new Date(),
        elapsedDurationMillisecond: prev.elapsedDurationMillisecond,
        deltaDurationMillisecond: 0,
        ...buildHourMinuteSecond(prev.elapsedDurationMillisecond),
      } as Timer
    })
    tickerRef.current = setInterval(() => {
      setTimer((prev: Timer) => {
        if (!prev.isRunning) return prev

        const newDeltaDurationMillisecond = prev?.startedAt
          ? new Date().getTime() - prev.startedAt.getTime()
          : 0
        console.log(newDeltaDurationMillisecond)
        return {
          ...prev,
          deltaDurationMillisecond: newDeltaDurationMillisecond,
          ...buildHourMinuteSecond(
            prev.elapsedDurationMillisecond + newDeltaDurationMillisecond,
          ),
        }
      })
    }, 1000)
  }

  const finishTimer = async () => {
    clearInterval(tickerRef.current)
    const newElapsedDurationMillisecond =
      timer.elapsedDurationMillisecond + timer.deltaDurationMillisecond
    setTimer({
      ...timer,
      isRunning: false,
      startedAt: null,
      elapsedDurationMillisecond: newElapsedDurationMillisecond,
      deltaDurationMillisecond: 0,
      ...buildHourMinuteSecond(newElapsedDurationMillisecond),
    })

    const resp = await repoutil.post(
      `practiceDays/${currentDate}/updateStatus`,
      {
        practiceDuration: `PT${newElapsedDurationMillisecond / 1000}S`,
      },
    )
    const data = await resp.json()
  }

  const onClickTimerText = () => {
    finishTimer()
    resetUpdateTimer({
      [TimeUnit.Enum.HOUR]: timer[TimeUnit.Enum.HOUR],
      [TimeUnit.Enum.MINUTE]: timer[TimeUnit.Enum.MINUTE],
      [TimeUnit.Enum.SECOND]: timer[TimeUnit.Enum.SECOND],
    })
    setOpenUpdateTimerDialog(true)
  }

  const onSubmitUpdateTimer = async (formData: UpdateTimerFormData) => {
    // Generate the aggregated milliseconds from update timer's hour, minute and second.
    const newElapsedDurationMillisecond =
      (formData[TimeUnit.Enum.HOUR] * 60 * 60 +
        formData[TimeUnit.Enum.MINUTE] * 60 +
        formData[TimeUnit.Enum.SECOND]) *
      1000
    const resp = await repoutil.post(
      `practiceDays/${currentDate}/updateStatus`,
      {
        practiceDuration: `PT${newElapsedDurationMillisecond / 1000}S`,
      },
    )
    const data = await resp.json()

    // update timer 's elapsed duration
    setTimer({
      ...timer,
      elapsedDurationMillisecond: newElapsedDurationMillisecond,
      ...buildHourMinuteSecond(newElapsedDurationMillisecond),
    })
    setOpenUpdateTimerDialog(false)
  }

  const onClickTimerPause = async () => {
    await finishTimer()
  }

  const handleSavePractice = async () => {
    await finishTimer()

    navigate(-1)
  }

  const onTaskDone = (e: Event, task: any) => {
    stop()
    setSpeed(1.5)
    play()
  }

  return (
    <>
      {View}
      <Grid
        className={styles.scrollbarHidden}
        container
        justifyContent={'center'}
        sx={style}
        py={2}
        px={2}
      >
        <Grid item xs={12}>
          <Grid container justifyContent={'space-between'}>
            <Grid item xs={12}>
              <Grid
                container
                direction={'row'}
                justifyContent={'center'}
                rowSpacing={2}
              >
                {/* Timer */}
                <Grid item xs={12}>
                  {(() => {
                    const resourceColor = '#FFFFFF'
                    return (
                      <Stack
                        direction={'row'}
                        style={{
                          background:
                            'linear-gradient(315deg, #ABD453 0%, #91D73E 30%, #91D73E 70%, #46E460 100%)',
                          borderRadius: '10px',
                          fontSize: '16px',
                        }}
                        alignItems={'center'}
                        padding={1}
                        spacing={'auto'}
                      >
                        <AccessTime style={{ color: resourceColor }} />
                        <Stack
                          style={{}}
                          justifyContent="center"
                          alignItems="center"
                          direction="row"
                          spacing={1}
                          onClick={onClickTimerText}
                        >
                          {[
                            TimeUnit.Enum.HOUR,
                            TimeUnit.Enum.MINUTE,
                            TimeUnit.Enum.SECOND,
                          ].map((unit, i) => (
                            <Fragment key={unit}>
                              <p
                                className="font-bold text-white bg-transparent"
                                style={{
                                  fontSize: '20px',
                                }}
                              >
                                {timeutil.to2Digits(timer[unit])}
                              </p>
                              {unit !== TimeUnit.Enum.SECOND && (
                                <span
                                  className="border-none focus:outline-none font-bold text-white bg-transparent"
                                  style={{ fontSize: '20px' }}
                                >
                                  :
                                </span>
                              )}
                            </Fragment>
                          ))}
                        </Stack>
                        {timer.isRunning ? (
                          <Pause
                            style={{ color: resourceColor }}
                            onClick={onClickTimerPause}
                          />
                        ) : (
                          <PlayArrow
                            style={{ color: resourceColor }}
                            onClick={onClickTimerPlay}
                          />
                        )}
                      </Stack>
                    )
                  })()}
                </Grid>
                {/* Timer 수정 dialog */}
                <Dialog
                  open={openUpdateTimerDialog}
                  onClose={() => setOpenUpdateTimerDialog(false)}
                  style={{ width: '100%' }}
                  PaperProps={{
                    style: {
                      width: '85%',
                      maxHeight: '95%',
                      margin: '0px',
                      scrollbarWidth: 'none',
                      borderRadius: '8px',
                    },
                  }}
                >
                  <DialogContent>
                    <Stack direction="row" spacing={1} justifyContent="center">
                      {[
                        TimeUnit.Enum.HOUR,
                        TimeUnit.Enum.MINUTE,
                        TimeUnit.Enum.SECOND,
                      ].map((unit, index) => (
                        <Controller
                          control={controlUpdateTimer}
                          name={unit}
                          key={unit}
                          render={({ field, formState: { errors } }) => (
                            <>
                              <TextField
                                inputRef={
                                  unit === TimeUnit.Enum.HOUR
                                    ? hourRef
                                    : unit === TimeUnit.Enum.MINUTE
                                    ? minuteRef
                                    : secondRef
                                }
                                type="number"
                                defaultValue={timeutil.to2Digits(timer[unit])}
                                onChange={(e: any) => {
                                  // if Enter or tab
                                  if (e.key === 'Enter' || e.key === 'Tab') {
                                    if (unit === TimeUnit.Enum.HOUR) {
                                      minuteRef.current?.focus()
                                    } else if (unit === TimeUnit.Enum.MINUTE) {
                                      secondRef.current?.focus()
                                    }
                                  } else {
                                    field.onChange(e)
                                  }
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                    max: 59,
                                    step: 1,
                                  },
                                  style: {
                                    textAlign: 'center',
                                    border: 'none',
                                  },
                                }}
                                style={{ width: '60px' }}
                              />
                              {unit !== TimeUnit.Enum.SECOND && <span>:</span>}
                            </>
                          )}
                        />
                      ))}
                    </Stack>
                    <Stack direction="row" justifyContent="center" mt={2}>
                      <GradientButton
                        style={{
                          fontSize: '16px',
                          textTransform: 'none',
                          borderRadius: '10px',
                          fontWeight: 'bold',
                        }}
                        disableElevation={true}
                        onClick={() => {
                          handleSubmitUpdateTimer(onSubmitUpdateTimer)()
                        }}
                      >
                        {t('SAVE')}
                      </GradientButton>
                    </Stack>
                  </DialogContent>
                </Dialog>
                {/* Practice Notes */}
                <Grid item xs={12}>
                  {pinnedPracticeNotes.length > 0 && (
                    <Typography color={GRAY_LIGHT} fontSize={'14px'} mb={1}>
                      {t('PINNED_POSTS')}
                    </Typography>
                  )}
                  <Stack spacing={1}>
                    {pinnedPracticeNotes.map((practiceNote, i) => (
                      <Typography
                        p={1.5}
                        sx={{
                          backgroundColor: 'white',
                          borderRadius: '10px',
                          '& fieldset': { border: 'none' },
                          whiteSpace: 'pre-wrap',
                        }}
                        fontSize={'16px'}
                        color={GRAY_DARK}
                      >
                        {practiceNote.content}
                      </Typography>
                    ))}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} marginTop={1}>
              <Typography fontWeight={'bold'}>
                {dateutil.formatDateToHumanString(new Date(currentDate))}{' '}
              </Typography>
            </Grid>

            <Grid item xs={12} mt={2}>
              <PracticeTaskListView
                practiceTasks={practiceDay ? practiceDay.practiceTasks : []}
                readonly={false}
                onTaskDone={onTaskDone}
                fallback={
                  <Typography
                    m={2}
                    color={GRAY_LIGHT}
                    fontStyle={'italic'}
                    textAlign={'center'}
                  >
                    {t('NO_PRACTICE_YET')}
                    <br />
                    {t('GUIDE_FOR_PRACTICE_CREATION')}
                  </Typography>
                }
              />
            </Grid>

            <Grid item xs={5.8} marginTop={3}>
              <OutlinedButton
                fullWidth
                variant="outlined"
                onClick={onClickAddTask}
                style={{
                  backgroundColor: 'white',
                  fontSize: '16px',
                  textTransform: 'none',
                  borderRadius: '10px',
                  fontWeight: 'bold',
                }}
              >
                {t('ADD_PRACTICE')}
              </OutlinedButton>
            </Grid>

            <Grid item xs={5.8} marginTop={3}>
              <GradientButton
                fullWidth
                variant="contained"
                onClick={onClickImportPractice}
                disableElevation={true}
                style={{
                  fontSize: '16px',
                  textTransform: 'none',
                  borderRadius: '10px',
                  fontWeight: 'bold',
                }}
              >
                {t('IMPORT_PRACTICE')}
              </GradientButton>
            </Grid>
            <Grid item xs={12} marginTop={1}>
              <GradientButton
                fullWidth
                variant="contained"
                onClick={handleSavePractice}
                style={{
                  fontSize: '16px',
                  textTransform: 'none',
                  borderRadius: '10px',
                  fontWeight: 'bold',
                }}
                disableElevation={true}
              >
                {t('FINISH')}
              </GradientButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

const OutlinedButton = styled(Button)<ButtonProps>(({ theme }) => ({
  backgroundColor: 'white',
  color: GREEN,
  textTransform: 'none',
  transition: theme.transitions.create(['background', 'transform'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    backgroundColor: 'white',
    transform: 'scale(1.05)',
  },
  '&:active': {
    backgroundColor: 'white',
    transform: 'scale(0.95)',
  },
  '&:disabled': {
    backgroundColor: 'white',
    color: theme.palette.text.disabled,
  },
}))
